import Vue from 'vue';
// @ts-ignore
import VTooltip from 'v-tooltip';
import store from '@/store';

const options = {
  popover: {
    defaultBaseClass: '',
    defaultInnerClass: 'creative-tooltip-inner creative-popover-inner',
    defaultArrowClass: 'creative-tooltip-arrow creative-popover-arrow'
  },
};

store.subscribe((mutation) => {
  if (mutation.type === 'setConfiguration') {
    options.popover.defaultBaseClass =
      store.getters.configuration.showPopovers === 'true'
        ? 'creative-tooltip creative-popover'
        : 'hide';
    Vue.use(VTooltip, options);
  }
});
